import React from 'react';
import { useCalendar } from '../calendarContext';
import MonthView from './monthView';
import { useIsMobile } from '../../../../util/utils'; // or your own path

const PrintableView = React.forwardRef((props, ref) => {
  const { currentMonth } = useCalendar();
  const isMobile = useIsMobile();

  return (
    <div ref={ref}>
      {MonthView && (
        <MonthView
          monthDate={currentMonth}
          showEventDetailsInside={!isMobile} // ✅ Show inside if not mobile
          showEventDetailsOutside={isMobile} // ✅ Show outside if mobile
          calculateHeight={true}
          {...props}
        />
      )}
    </div>
  );
});

export default PrintableView;
